/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChartResponseFromJSON, ApiChartResponseToJSON, } from './ApiChartResponse';
export function ApiAlertNotificationResponseFromJSON(json) {
    return ApiAlertNotificationResponseFromJSONTyped(json, false);
}
export function ApiAlertNotificationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : ApiChartResponseFromJSON(json['chart']),
        'chartFrom': !exists(json, 'chartFrom') ? undefined : (new Date(json['chartFrom'])),
        'chartLastNDays': !exists(json, 'chartLastNDays') ? undefined : json['chartLastNDays'],
        'chartTo': !exists(json, 'chartTo') ? undefined : (new Date(json['chartTo'])),
        'comparisonFrom': !exists(json, 'comparisonFrom') ? undefined : (new Date(json['comparisonFrom'])),
        'comparisonTo': !exists(json, 'comparisonTo') ? undefined : (new Date(json['comparisonTo'])),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}
export function ApiAlertNotificationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': ApiChartResponseToJSON(value.chart),
        'chartFrom': value.chartFrom === undefined ? undefined : (value.chartFrom.toISOString()),
        'chartLastNDays': value.chartLastNDays,
        'chartTo': value.chartTo === undefined ? undefined : (value.chartTo.toISOString()),
        'comparisonFrom': value.comparisonFrom === undefined ? undefined : (value.comparisonFrom.toISOString()),
        'comparisonTo': value.comparisonTo === undefined ? undefined : (value.comparisonTo.toISOString()),
        'message': value.message,
    };
}
